import CovidTrackerImg from "../../../../assets/DeveloperProj/CovidTracker2.png";
import MovieStreamApp from "../../../../assets/DeveloperProj/MovieStreamApp.jpg";
import CartImg from "../../../../assets/DesignProj/icons8-fast-cart-64.png";
import AILogo from "../../../../assets/DeveloperProj/AILogo.png";
import ChatRoomIcon from "../../../../assets/DeveloperProj/icons8-chat-room-100.png";
import NFTArtCreator from "../../../../assets/DeveloperProj/NFTArtCreator.png";
import FundFu from "../../../../assets/DesignProj/FundFu.png";

export const projectsData = [
  {
    className: "landscapeProj movieStreamProj",
    data: "fade-up",
    delay: "400",
    duration: "1000",
    link: "https://coronavirustracker-2bc65.web.app/",
    Img: CovidTrackerImg,
    altText: "NFT Art Generator Image",
    text: "",
    innerClass: "imgWrapper",
    innerdata: "",
    innerduration: "",
    innerdelay: "",
    imgTextClass: "hideInfo",
  },
  {
    className: "leftProj",
    data: "fade-right",
    delay: "300",
    duration: "700",
    link: "https://github.com/chwasiq0569/FundFU_CrowdFundingMobileApp",
    altText: "Crowdfunding Mobile App",
    text: "Crowdfunding Mobile App",
    Img: FundFu,
    innerTextClass: "titleHead portfoliodesign",
    innerClass: "imgWrapper",
    innerdata: "",
    innerduration: "",
    innerdelay: "",
  },
  {
    className: "rightProj",
    data: "fade-left",
    delay: "300",
    duration: "700",
    link: "https://github.com/chwasiq0569/Potato-Disease-Class-Heroku",
    Img: AILogo,
    altText: "Potato Disease Classification",
    text: "Potato Disease Classification using AI",
    altText: "Ecommerce App Image",
    innerTextClass: "titleHead",
    innerClass: "imgWrapper",
    innerdata: "",
    innerduration: "",
    innerdelay: "",
  },
  {
    className: "landscapeProj coviddesign",
    data: "fade-up",
    delay: "750",
    duration: "1000",
    link: "https://streamproject-4ce54.web.app/",
    Img: MovieStreamApp,
    altText: "Stream App Image",
    text: "Stream App",
    altText: "Stream App Image",
    innerTextClass: "titleHead",
    innerClass: "imgWrapper",
    innerdata: "",
    innerduration: "",
    innerdelay: "",
  }, {
    className: "landscapeProj nftartcreatorproj",
    data: "fade-up",
    delay: "400",
    duration: "1000",
    link: "https://github.com/chwasiq0569/NFTArtGenerationAIFinal",
    Img: NFTArtCreator,
    altText: "NFT Art Generator Image",
    text: "",
    innerClass: "imgWrapper",
    innerdata: "",
    innerduration: "",
    innerdelay: "",
    imgTextClass: "hideInfo",
  }
];
